import { useState, useEffect } from "react";
import axios from "axios"
import { GiCarDoor } from "react-icons/gi";
import { MdOutlineAirlineSeatReclineNormal } from "react-icons/md";
import { TbAirConditioning } from "react-icons/tb";
import { LuFuel } from "react-icons/lu";
import { IoMusicalNotesOutline } from "react-icons/io5";
import CabInquiryModal from "components/UserSideComponents/Modal/CabInquiryModal";

// ─── DATA ────────────────────────────────────────────────────────────────────
const carTypes = [
  { label: "Sedan",      count: 216, img: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=120&q=80" },
  { label: "Sports",     count: 569, img: "https://images10.gaadi.com/usedcar_image/5025798/original/9bfd83e6-c6f8-46ff-9945-1836945c48b4.png?imwidth=640" },
  { label: "SUV",        count: 129, img: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=120&q=80" },
  { label: "Convertible",count: 600, img: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=120&q=80" },
  { label: "Crossover",  count: 200, img: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=120&q=80" },
  { label: "EV",         count: 180, img: "https://www.jazzycars.in/wp-content/uploads/2023/11/WhatsApp-Image-2023-12-02-at-11.12.29.jpeg" },
];

const cars = [
  { id:1, name:"Toyota Camry SE 400",       location:"Ciutat Vella, Barcelona",   category:"Sedan", fuel:"Hybrid", gear:"Manual", km:"14,000 KM", price:500, rating:5.0, reviews:400, fav:true,  desc:"Enjoy modern comfort, cutting-edge technology, and exceptional handling for every journey, from city streets to off-road adventures.", avatar:"https://randomuser.me/api/portraits/men/32.jpg",   imgs:["https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=600&q=80","https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600&q=80","https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=600&q=80"] },
  { id:2, name:"Ford Mustang 4.0 AT",       location:"Oxford Street, London",     category:"Sedan", fuel:"Hybrid", gear:"Auto",   km:"12,000 KM", price:600, rating:5.0, reviews:300, fav:true,  desc:"A powerful and dynamic vehicle, built for those who crave adventure with a smooth ride and impressive handling.", avatar:"https://randomuser.me/api/portraits/women/44.jpg", imgs:["https://images10.gaadi.com/usedcar_image/5025798/original/9bfd83e6-c6f8-46ff-9945-1836945c48b4.png?imwidth=640","https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=600&q=80","https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=600&q=80"] },
  { id:3, name:"Ferrari 458 MM Special",    location:"Princes Street, Edinburgh", category:"Sedan", fuel:"Hybrid", gear:"Manual", km:"13,000 KM", price:300, rating:4.0, reviews:320, fav:false, desc:"Modern and elegant, this car combines innovative features with a sleek design, offering a premium driving experience.", avatar:"https://randomuser.me/api/portraits/men/55.jpg",   imgs:["https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=600&q=80","https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=600&q=80","https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=600&q=80"] },
  { id:4, name:"Mercedes-Benz Convertible", location:"Princes Street, Edinburgh", category:"Sedan", fuel:"Petrol", gear:"Auto",   km:"10,000 KM", price:400, rating:4.0, reviews:380, fav:false, desc:"Sleek and stylish, this car offers a blend of performance and luxury, with cutting-edge technology and a comfortable interior.", avatar:"https://randomuser.me/api/portraits/women/63.jpg", imgs:["https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600&q=80","https://images.unsplash.com/photo-1584345604476-8ec5f82d661f?w=600&q=80","https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=600&q=80"] },
  { id:5, name:"BMW 3.0 Gran Turismo",      location:"King's Road, Chelsea",      category:"Sedan", fuel:"Petrol", gear:"Manual", km:"12,800 KM", price:500, rating:4.3, reviews:300, fav:false, desc:"Reliable and fuel-efficient, perfect for daily commutes or long drives, this car is designed for both convenience and economy.", avatar:"https://randomuser.me/api/portraits/men/71.jpg",   imgs:["https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=600&q=80","https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=600&q=80","https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=600&q=80"] },
  { id:6, name:"Infiniti QX60",             location:"Bold Street, Liverpool",    category:"Sedan", fuel:"Diesel", gear:"Auto",   km:"13,500 KM", price:450, rating:4.1, reviews:450, fav:false, desc:"Spacious and versatile, this car is ideal for families, offering advanced safety features and a roomy interior for maximum comfort.", avatar:"https://randomuser.me/api/portraits/women/29.jpg", imgs:["https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=600&q=80","https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600&q=80","https://images.unsplash.com/photo-1584345604476-8ec5f82d661f?w=600&q=80"] },
  { id:7, name:"Toyota 86 Sports",          location:"Broad Street, Bristol",     category:"Sedan", fuel:"Hybrid", gear:"Auto",   km:"15,000 KM", price:350, rating:4.6, reviews:520, fav:false, desc:"Compact and efficient, perfect for city driving, this car boasts excellent fuel economy and easy maneuverability.", avatar:"https://randomuser.me/api/portraits/men/88.jpg",   imgs:["https://www.jazzycars.in/wp-content/uploads/2023/11/WhatsApp-Image-2023-12-02-at-11.12.29.jpeg","https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600&q=80","https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=600&q=80"] },
];

const sortOptions = ["Recommended","Price: low to high","Price: high to low","Newest","Ratings","Reviews"];
const brands = ["Toyota","Ford","Honda","BMW","Mercedes-Benz","Tesla","Audi","Chevrolet"];
const carTypeOpts = ["Sedan","EV","Crossover","Sports","Van","Wagon","SUV"];
const fuelOpts = ["Petrol","Diesel","Hybrid","CNG","EV"];
const gearOpts = ["Manual","Auto","Hybrid"];
const capacityOpts = ["2 Seater","4 Seater","5 Seater","7 Seater"];
const starOpts = [5,4,3,2,1];
const dropModes = ["Same drop-off","Different Drop off","Airport","Hourly Package"];
const locations = [{name:"USA",count:"2000 Cars"},{name:"Japan",count:"3000 Cars"},{name:"Singapore",count:"8000 Cars"},{name:"Russia",count:"8000 Cars"},{name:"Germany",count:"6000 Cars"}];

// ─── ICONS ───────────────────────────────────────────────────────────────────
const Icon = {
  Heart: ({filled}) => <svg className={`w-5 h-5 ${filled?"fill-red-500 stroke-red-500":"stroke-white fill-transparent"}`} strokeWidth={1.8} viewBox="0 0 24 24"><path d="M7.75 3.5C5.127 3.5 3 5.76 3 8.547 3 14.125 12 20.5 12 20.5S21 14.125 21 8.547C21 5.094 18.873 3.5 16.25 3.5c-1.86 0-3.47 1.136-4.25 2.79C11.22 4.637 9.61 3.5 7.75 3.5Z"/></svg>,
  Location: () => <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 14 6 14s6-8.75 6-14c0-3.314-2.686-6-6-6Zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/></svg>,
  Fuel: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M4 22V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4h1a2 2 0 0 1 2 2v5a1 1 0 0 0 2 0V9l-2-2"/><rect x="4" y="10" width="12" height="6" rx="1"/></svg>,
  Gear: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M12 3v3m0 12v3M3 12h3m12 0h3m-3.5-7.5-2.1 2.1M8.6 15.4 6.5 17.5m11-2.1-2.1-2.1M8.6 8.6 6.5 6.5"/><circle cx="12" cy="12" r="3"/></svg>,
  Route: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M3 17h3a3 3 0 0 0 6 0h2a3 3 0 0 0 6 0h1M3 7h12l4 6H3V7Z"/></svg>,
  Star: () => <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z"/></svg>,
  Trend: () => <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
  ChevL: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>,
  ChevR: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>,
  ChevD: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>,
  ChevU: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M18 15l-6-6-6 6"/></svg>,
  Grid: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  List: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>,
  Map: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>,
  Search: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>,
  Info: () => <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/></svg>,
  Filter: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>,
  Close: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>,
  Swap: () => <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M7 16V4m0 0L3 8m4-4 4 4M17 8v12m0 0 4-4m-4 4-4-4"/></svg>,
  Car: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M5 17H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1l3-4h8l3 4h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2M7 17a2 2 0 1 0 4 0M13 17a2 2 0 1 0 4 0"/></svg>,
};

// ─── IMAGE CAROUSEL ──────────────────────────────────────────────────────────
function Carousel({ imgs }) {
  const [cur, setCur] = useState(0);
  const prev = (e) => { e.stopPropagation(); setCur((c) => (c - 1 + imgs.length) % imgs.length); };
  const next = (e) => { e.stopPropagation(); setCur((c) => (c + 1) % imgs.length); };
  return (
    <div className="relative w-full h-full overflow-hidden group bg-gray-100">
      {imgs.map((src, i) => (
        <img key={i} src={src} alt="" className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${i === cur ? "opacity-100" : "opacity-0"}`} />
      ))}
      <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity shadow-md z-10"><Icon.ChevL /></button>
      <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity shadow-md z-10"><Icon.ChevR /></button>
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10">
        {imgs.map((_, i) => <button key={i} onClick={(e) => { e.stopPropagation(); setCur(i); }} className={`h-1.5 rounded-full transition-all ${i === cur ? "bg-white w-4" : "bg-white/60 w-1.5"}`} />)}
      </div>
    </div>
  );
}

// ─── ACCORDION FILTER SECTION ────────────────────────────────────────────────
function AccordionSection({ icon, title, children }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="border-b border-gray-100 py-3 px-4">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-left">
        <span className="flex items-center gap-2 text-sm font-semibold text-gray-800">
          <span className="text-blue-600">{icon}</span>{title}
        </span>
        {open ? <Icon.ChevU /> : <Icon.ChevD />}
      </button>
      {open && <div className="mt-3">{children}</div>}
    </div>
  );
}

// ─── CHECKBOX ROW ────────────────────────────────────────────────────────────
function CheckRow({ label, checked, onChange }) {
  return (
    <label className="flex items-center gap-2 mb-2 cursor-pointer group relative">

      {/* Real checkbox */}
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="absolute opacity-0 w-4 h-4 cursor-pointer"
      />

      {/* Custom checkbox */}
      <div
        className={`w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors
        ${checked ? "bg-[#FD5200] border-[#FD5200]" : "border-gray-300 group-hover:border-[#FD5200]"}`}
      >
        {checked && (
          <svg
            className="w-2.5 h-2.5 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth={3}
            viewBox="0 0 24 24"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>

      <span className="text-sm text-gray-600 group-hover:text-gray-900">
        {label}
      </span>
    </label>
  );
}

// ─── RANGE SLIDER ────────────────────────────────────────────────────────────
function RangeSlider({ label, min, max, value, onChange, unit="" }) {
  return (
    <div>
      <input type="range" min={min} max={max} value={value} onChange={e => onChange(Number(e.target.value))} className="w-full accent-[#FD5200] mb-1" />
      <p className="text-xs text-gray-500">Range: <span className="font-semibold text-gray-800">{unit}{min} – {unit}{value}</span></p>
    </div>
  );
}

// ─── STAR DISPLAY ────────────────────────────────────────────────────────────
function Stars({ count }) {
  return (
    <span className="flex items-center gap-0.5">
      {Array.from({length:5}).map((_,i) => (
        <svg key={i} className={`w-3 h-3 ${i < count ? "fill-[#FD5200] text-[#FD5200]" : "fill-gray-200 text-gray-200"}`} viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z"/>
        </svg>
      ))}
    </span>
  );
}

// ─── SIDEBAR FILTERS CONTENT ─────────────────────────────────────────────────
function FiltersContent({ onReset,
  selectedBrands,
  setSelectedBrands,
  selectedFuelType,
  setSelectedFuelType,
  selectedCabType,
  setSelectedCabType,
  selectedCapacity,
  setSelectedCapacity,
  brands,
  cabTypes,
  fuelTypes,
  capacity,
  priceMax,
  setPriceMax,
  minPrice,
  maxPrice
}) {
  // const [priceMax, setPriceMax] = useState(5695);
  // const [kmMax, setKmMax] = useState(20000);
  // const [selectedTypes, setSelectedTypes] = useState(["Sedan","Sports","SUV"]);
  // const [selectedFuel, setSelectedFuel] = useState([]);
  // const [selectedGear, setSelectedGear] = useState([]);
  // const [selectedCap, setSelectedCap] = useState(["7 Seater"]);
  // const [selectedStars, setSelectedStars] = useState([]);
  // const [showAllBrands, setShowAllBrands] = useState(true);
  // const [search, setSearch] = useState("");

 
function toggleMulti(selected, setSelected, value) {
  if (selected.includes(value)) {
    setSelected(selected.filter(v => v !== value)); // uncheck it
  } else {
    setSelected([...selected, value]); // add to existing selections
  }
}

  return (
    <div>
      {/* Search */}
      {/* <div className="px-4 py-3 border-b border-gray-100">
        <label className="text-sm font-semibold text-gray-800 block mb-2">Search by Car Name</label>
        <div className="relative">
          <Icon.Search />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by Car Name"
            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-blue-400" />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><Icon.Search /></span>
        </div>
      </div> */}

      <AccordionSection icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>} title="Price Per Km">
        <RangeSlider
  min={minPrice}
  max={maxPrice}
  value={priceMax}
  onChange={setPriceMax}
  unit="₹"
/>
      </AccordionSection>

      <AccordionSection icon={<Icon.Car />} title="Car Brands">
       {brands.map(b => (
  <CheckRow
    key={b}
    label={b}
    checked={selectedBrands.includes(b)}
    onChange={() => toggleMulti(selectedBrands, setSelectedBrands, b)}
  />
         ))}
      </AccordionSection>

      <AccordionSection icon={<Icon.Car />} title="Car Type">
         {cabTypes.map(ct => (
  <CheckRow
    key={ct}
    label={ct}
    checked={selectedCabType.includes(ct)}
    onChange={() => toggleMulti(selectedCabType, setSelectedCabType, ct)}
  />
         ))}
      </AccordionSection>

      <AccordionSection icon={<Icon.Fuel />} title="Fuel">
        {fuelTypes.map(f => (
  <CheckRow
    key={f}
    label={f}
    checked={selectedFuelType.includes(f)}
    onChange={() => toggleMulti(selectedFuelType, setSelectedFuelType, f)}
  />
))}
      </AccordionSection>

      {/* <AccordionSection icon={<Icon.Gear />} title="Gear">
        {gearOpts.map(g => <CheckRow key={g} label={g} checked={selectedGear.includes(g)} onChange={() => toggle(selectedGear, setSelectedGear, g)} />)}
      </AccordionSection> */}

      <AccordionSection icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>} title="Capacity">
        {capacity.map(s => (
  <CheckRow
    key={s}
    label={s}
    checked={selectedCapacity.includes(s)}
    onChange={() => toggleMulti(selectedCapacity, setSelectedCapacity, s)}
  />
))}
      </AccordionSection>

      {/* <AccordionSection icon={<Icon.Route />} title="Travelled">
        <RangeSlider min={1000} max={30000} value={kmMax} onChange={setKmMax} unit="" />
        <p className="text-xs text-gray-500 mt-1">Range: <span className="font-semibold text-gray-800">10,000 Km – {kmMax.toLocaleString()} Km</span></p>
      </AccordionSection> */}

      {/* <AccordionSection icon={<Icon.Star />} title="Reviews">
        {reviews.map(n => (
          <label key={n} className="flex items-center gap-2 mb-2 cursor-pointer">
            <div onClick={() => toggleMulti(selectedReviews, setSelectedReviews, n)} className={`w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors ${selectedReviews.includes(n) ? "bg-blue-600 border-blue-600" : "border-gray-300"}`}>
              {selectedReviews.includes(n) && <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>}
            </div>
            <Stars count={n} />
            <span className="text-sm text-gray-600">{n} Star</span>
          </label>
        ))}
      </AccordionSection> */}

      <div className="p-4">
        <button onClick={onReset} className="w-full py-2 text-sm font-medium border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors">
          Reset All Filters
        </button>
      </div>
    </div>
  );
}

// ─── LOCATION DROPDOWN ────────────────────────────────────────────────────────
function LocationDropdown({ label, value, onChange }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative flex-1 min-w-0">
      <button onClick={() => setOpen(!open)} className="w-full text-left p-2 border-r border-gray-100 last:border-r-0">
        <p className="text-xs text-gray-500 mb-0.5">{label}</p>
        <p className="text-sm font-semibold text-gray-900 truncate">{value}</p>
        <p className="text-xs text-gray-400">USA</p>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-full mt-1 z-20 bg-white border border-gray-100 rounded-xl shadow-xl w-64 overflow-hidden">
            <div className="p-3 border-b border-gray-100">
              <div className="flex items-center gap-2 border border-gray-200 rounded-lg px-3 py-2">
                <Icon.Search />
                <input placeholder="Search..." className="flex-1 text-sm outline-none" />
              </div>
            </div>
            <ul>
              {locations.map(l => (
                <li key={l.name}>
                  <button onClick={() => { onChange(l.name); setOpen(false); }} className="w-full text-left px-4 py-2.5 hover:bg-gray-50 border-b border-gray-50 last:border-0">
                    <p className="text-sm font-semibold text-gray-800">{l.name}</p>
                    <p className="text-xs text-gray-400">{l.count}</p>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}



// ─── CAR LIST CARD ────────────────────────────────────────────────────────────
function CarListCard({ car, onClick }) {
  const [fav, setFav] = useState(car.fav);
     useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div onClick={onClick} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow mb-4 overflow-hidden flex flex-col sm:flex-row">
      {/* Image */}
      <div className="relative w-full h-48 sm:w-64 sm:h-auto lg:w-80 flex-shrink-0">
        <Carousel imgs={car?.subImages} />
        {/* Overlays */}
        <div className="absolute top-3 left-3 right-3 flex items-center justify-between z-10">
          <button onClick={() => setFav(!fav)} className="w-8 h-8 bg-black/30 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-black/50 transition-colors">
            <Icon.Heart filled={fav} />
          </button>
          <span className="flex items-center gap-1 bg-[#FD5200] text-white text-xs font-bold px-2 py-1 rounded-full">
            <Icon.Trend /> Trending
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-4 sm:p-5 flex flex-col justify-between">
        {/* Top */}
        <div>
          <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
            <div>
              <div className="flex items-center gap-2 flex-wrap mb-1">
                <h3 className="font-bold text-gray-900 text-base sm:text-lg truncate max-w-xs hover:text-blue-600 cursor-pointer transition-colors">
                  {car?.name}
                </h3>
                {/* <span className="text-xs font-semibold bg-gray-100 text-gray-600 px-2 py-0.5 rounded flex-shrink-0">{car.category}</span> */}
              </div>
              <p className="flex items-center gap-1 text-sm text-gray-500">
                {/* <Icon.Location /> {car?.location} */}
              </p>
            </div>
            {/* Avatar + Rating */}
            <div className="flex items-center gap-2 flex-shrink-0">
              {/* <img src={car?.avatar} alt="" className="w-8 h-8 rounded-full object-cover border-2 border-white shadow" /> */}
              <div className="flex items-center gap-1 border-l border-gray-100 pl-2">
                <span className="flex items-center gap-1 bg-amber-400 text-white text-xs font-bold px-2 py-0.5 rounded">
                  <Icon.Star /> {car?.avgRating}
                </span>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-500 leading-relaxed mb-4 line-clamp-2">{car?.description}</p>
          <div className="flex gap-10">
              <span className="text-sm font-medium capitalize">{car?.brand}</span>
              <span className="text-sm font-medium capitalize">{car?.model}</span>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-wrap items-center justify-between gap-3">
          {/* Specs pill */}
          <div className="flex flex-wrap items-center gap-0 border border-gray-100 rounded-xl overflow-hidden capitalize">
            {[
              { icon: <LuFuel />, val: car?.fuelType },
              { icon: <MdOutlineAirlineSeatReclineNormal />, val: car?.seats },
              { icon: <TbAirConditioning />, val: car?.ac ? "Yes" : "No" },
              { icon: <IoMusicalNotesOutline />,val: car?.music ? "Yes" : "No" },
              { icon: <GiCarDoor />, val: car?.door },
            ].map((spec, i) => (
              <div key={i} className={`flex items-center gap-1.5 px-3 py-2 ${i < 2 ? "border-r border-gray-100" : ""}`}>
                <span className="text-gray-400">{spec.icon}</span>
                <span className="text-xs text-gray-400">{spec.label}:</span>
                <span className="text-xs font-semibold text-gray-800 whitespace-nowrap">{spec.val}</span>
              </div>
            ))}
          </div>
          {/* Price */}
          <div className="text-right">
            <span className="text-blue-600 font-bold text-xl">₹{car?.price}</span>
            <span className="text-gray-400 text-sm"> / Km</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── PAGINATION ───────────────────────────────────────────────────────────────
function Pagination({ page,totalPages,fetchCabsData }) {
    //  useEffect(() => {
    //   window.scrollTo(0, 0);
    // }, []);
  return (
    <div className="mt-6 flex items-start gap-2">
          <button
            disabled={page === 1}
            onClick={() => fetchCabsData(page - 1)}
            className="rounded border px-3 py-1 disabled:opacity-50"
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => fetchCabsData(index + 1)}
              className={`rounded border px-3 py-1 ${
                page === index + 1 ? "bg-red-500 text-white" : ""
              }`}
            >
              {index + 1}
            </button>
          ))}

          <button
            disabled={page === totalPages}
            onClick={() => fetchCabsData(page + 1)}
            className="rounded border px-3 py-1 disabled:opacity-50"
          >
            Next
          </button>
        </div>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────────────────────
export default function CarListPage() {
  const [filterOpen, setFilterOpen] = useState(false);
  const [cab, setCab] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedCabType, setSelectedCabType] = useState([])
  const [selectedFuelType, setSelectedFuelType] = useState([])
  const [selectedCapacity, setSelectedCapacity] = useState([])
  const [priceMax, setPriceMax] = useState(0);
   const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedCab, setSelectedCab] = useState(null);
const [modalOpen, setModalOpen] = useState(false);
  

  const prices = cab.map(car => car.price);

const minPrice = prices.length ? Math.min(...prices) : 0;
const maxPrice = prices.length ? Math.max(...prices) : 100;
 
const fetchCabData = async (pageNumber = 1) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/cab/all-cab?page=${pageNumber}&limit=8`);
    const data = response?.data?.data || [];
    setCab(data);
      setTotalPages(response?.data?.totalPages);
      setPage(pageNumber);

    // Set priceMax to the highest price automatically
    const prices = data.map(car => car.price);
    const maxPrice = prices.length ? Math.max(...prices) : 100; // fallback
    setPriceMax(maxPrice);

    console.log("cabPackage response data", data);
  } catch (error) {
    console.log(error);
  }
};

  useEffect(() => {
    fetchCabData();
  }, []);
  
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  const brands = [...new Set(cab.map(car => car?.brand))];
  const cabTypes = [...new Set(cab.map(car => car?.cabType))]
  const fuelTypes = [...new Set(cab.map(car => car?.fuelType))]
  const capacity = [...new Set(cab.map(car => car?.seats))]
  

 const filteredCars = cab.filter((car) => {
  const brandMatch =
    selectedBrands.length === 0 || selectedBrands.includes(car.brand);

  const fuelMatch =
    selectedFuelType.length === 0 || selectedFuelType.includes(car.fuelType);

  const typeMatch =
    selectedCabType.length === 0 || selectedCabType.includes(car.cabType);

  const seatMatch =
    selectedCapacity.length === 0 || selectedCapacity.includes(car.seats);

   const matchPrice = car?.price <= priceMax;

  return brandMatch && fuelMatch && typeMatch && seatMatch && matchPrice;
});

  return (
    <div className="">
            <div className="relative h-[400px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1400&q=80"
          alt="Banner"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 " />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <h1 className="text-3xl md:text-4xl font-black tracking-tight text-white drop-shadow-lg">Car List</h1>
          <div className="flex items-center gap-2 mt-2 text-slate-300 text-sm">
            <span>🏠</span>
            <span className="text-slate-400">›</span>
            <span>Cars</span>
            <span className="text-slate-400">›</span>
            <span className="text-amber-400 font-medium">Car List</span>
          </div>
        </div>
      </div>
      <div className="w-full mx-auto px-4 sm:px-8 lg:px-20 md:py-10 py-6">

        {/* ── SEARCH FORM ── */}
   
          {/* Drop mode radios + title */}
          {/* <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {dropModes.map(m => (
                <label key={m} className="flex items-center gap-2 cursor-pointer">
                  <div onClick={() => setDropMode(m)} className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors ${dropMode===m?"border-[#FD5200]":"border-gray-300"}`}>
                    {dropMode===m && <div className="w-2 h-2 rounded-full bg-[#FD5200]"/>}
                  </div>
                  <span className="text-sm text-gray-600">{m}</span>
                </label>
              ))}
            </div>
            <h6 className="font-semibold text-gray-800 text-sm">Book Car for rental</h6>
          </div> */}

          {/* Fields */}
          {/* <div className="flex flex-col lg:flex-row gap-3">
            <div className="flex flex-1 border border-gray-100 rounded-xl overflow-hidden divide-x divide-gray-100 flex-wrap sm:flex-nowrap">
              <LocationDropdown label="From" value={from} onChange={setFrom} />
              {/* Swap icon in between */}
              {/* <div className="flex items-center justify-center px-1 border-x border-gray-100 bg-gray-50">
                <div className="w-6 h-6 bg-[#FD5200] rounded-full flex items-center justify-center text-white flex-shrink-0">
                  <Icon.Swap />
                </div>
              </div>
              <LocationDropdown label="To" value={to} onChange={setTo} />
              {[
                {label:"Departure", val:"21-10-2024", sub:"Monday"},
                {label:"Return",    val:"23-10-2024", sub:"Wednesday"},
                {label:"Pickup Time", val:"11:45 PM", sub:""},
                {label:"Dropoff Time",val:"11:45 PM", sub:""},
              ].map((f,i) => (
                <div key={i} className="flex-1 min-w-0 p-2 border-r border-gray-100 last:border-r-0">
                  <p className="text-xs text-gray-500 mb-0.5">{f.label}</p>
                  <input defaultValue={f.val} className="w-full text-sm font-semibold text-gray-900 outline-none bg-transparent min-w-0" />
                  {f.sub && <p className="text-xs text-gray-400">{f.sub}</p>}
                </div>
              ))}
            </div>
            <button className="lg:self-stretch px-8 py-3 bg-[#FD5200] text-white font-semibold rounded-xl transition-colors whitespace-nowrap">
              Search
            </button>
          </div>  */}
        

        {/* ── CAR TYPE SELECTOR ── */}
        {/* <div className="mb-6">
          <h5 className="font-bold text-gray-900 text-base mb-3">Choose type of Cars you are interested</h5>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5 gap-3">
            {cab?.map(ct => (
              <button key={ct.label} className="flex items-center gap-2 p-1 bg-white rounded-xl border border-gray-100 shadow-sm hover:border-blue-300 hover:shadow-md transition-all group">
                <img src={ct?.mainImage} alt={ct.label} className="w-10 h-10 rounded-full object-cover flex-shrink-0" />
                <div className="text-left min-w-0">
                  <p className="text-sm font-semibold text-gray-800 group-hover:text-[#FD5200] truncate">{ct.label}</p>
                  <p className="text-xs text-gray-400">{ct.length} Cars</p>
                </div>
              </button>
            ))}
          </div>
        </div> */}

        {/* ── MAIN LAYOUT ── */}
        <div className="flex gap-5 items-start">

          {/* Sidebar – Desktop */}
          <aside className="hidden lg:block w-64 xl:w-72 sticky top-20 self-start flex-shrink-0">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
                <h5 className="font-bold text-gray-900 text-base">Filters</h5>
                <button className="text-sm text-[#FD5200] font-medium hover:underline">Reset</button>
              </div>
              <FiltersContent
  brands={brands}
  cabTypes={cabTypes}
  fuelTypes={fuelTypes}
  capacity={capacity}
 

  selectedBrands={selectedBrands}
  setSelectedBrands={setSelectedBrands}

  selectedFuelType={selectedFuelType}
  setSelectedFuelType={setSelectedFuelType}

  selectedCabType={selectedCabType}
  setSelectedCabType={setSelectedCabType}

  selectedCapacity={selectedCapacity}
  setSelectedCapacity={setSelectedCapacity}

  priceMax={priceMax}
  setPriceMax={setPriceMax}


  minPrice={minPrice}
  maxPrice={maxPrice}

  onReset={() => {
    setSelectedBrands([]);
    setSelectedFuelType([]);
    setSelectedCabType([]);
    setSelectedCapacity([]);
    setPriceMax(maxPrice)
  }}
/>
            

          {/* Mobile Filter Drawer */}
         
          </div>
          </aside>

           {filterOpen && <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setFilterOpen(true)} />}
          <div className={`fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white rounded-t-3xl shadow-2xl transition-transform duration-300 max-h-[85vh] overflow-y-auto ${filterOpen ? "translate-y-0" : "translate-y-full"}`}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 sticky top-0 bg-white z-10">
              <h5 className="font-bold text-gray-900 text-base">Filters</h5>
              <button onClick={() => setFilterOpen(false)} className="text-gray-400 hover:text-gray-600"><Icon.Close /></button>
            </div>
            <FiltersContent
  brands={brands}
  cabTypes={cabTypes}
  fuelTypes={fuelTypes}
  capacity={capacity}
  

  selectedBrands={selectedBrands}
  setSelectedBrands={setSelectedBrands}

  selectedFuelType={selectedFuelType}
  setSelectedFuelType={setSelectedFuelType}

  selectedCabType={selectedCabType}
  setSelectedCabType={setSelectedCabType}

  selectedCapacity={selectedCapacity}
  setSelectedCapacity={setSelectedCapacity}

  priceMax={priceMax}
  setPriceMax={setPriceMax}

  
  minPrice={minPrice}
  maxPrice={maxPrice}


 
  onReset={() => {
    setSelectedBrands([]);
    setSelectedFuelType([]);
    setSelectedCabType([]);
    setSelectedCapacity([]);
    setPriceMax(maxPrice)
    setFilterOpen(false)
  }}
/>
            <div className="p-4 border-t border-gray-100 sticky bottom-0 bg-white">
              <button onClick={() => setFilterOpen(false)} className="w-full py-3 bg-[#FD5200] text-white font-semibold rounded-xl hover:bg-[#e04a00] transition-colors">
                Apply Filters
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            {/* Topbar */}
            <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
              <div className="flex items-center gap-3">
                {/* Mobile filter button */}
                <button onClick={() => setFilterOpen(true)} className="lg:hidden flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50">
                  <Icon.Filter /> Filters
                </button>
                <h6 className="font-semibold text-gray-800 text-sm">{filteredCars.length} Cars Found</h6>
              </div>
              {/* <div className="flex items-center gap-2">
                
                <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-lg p-1">
                  {[{k:"grid",i:<Icon.Grid/>},{k:"list",i:<Icon.List/>},{k:"map",i:<Icon.Map/>}].map(({k,i}) => (
                    <button key={k} onClick={() => setView(k)} className={`p-1.5 rounded-md transition-colors ${view===k?"bg-[#FD5200] text-white":"text-gray-500 hover:bg-gray-100"}`}>{i}</button>
                  ))}
                </div>
                
              </div> */}
            </div>

            {/* Info banner */}
            {/* <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-5 flex flex-wrap items-center justify-between gap-3">
              <p className="flex items-center gap-2 text-sm font-medium text-gray-800">
                <Icon.Info /> Save an average of 15% on thousands of hotels when you're signed in
              </p>
              <button className="px-4 py-1.5 bg-white border border-blue-200 text-blue-700 text-sm font-semibold rounded-lg hover:bg-blue-50 transition-colors shadow-sm">
                Sign In
              </button>
            </div> */}

            {/* Car List */}
            <div>
              {filteredCars?.map(car => <CarListCard key={car._id} car={car} onClick={() => { setSelectedCab(car); setModalOpen(true); }}/>)}
            </div>

            {/* Pagination */}
            <Pagination page={page} totalPages={totalPages} fetchCabsData={fetchCabData} />
          </div>
        </div>
      </div>

      {/* ── MOBILE FIXED FILTER BUTTON ── */}
      {/* <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-20 lg:hidden">
        <button onClick={() => setFilterOpen(true)} className="flex items-center gap-2 px-6 py-3 bg-[#FD5200] text-white font-semibold rounded-full shadow-2xl hover:bg-[#e04a00] transition-colors">
          <Icon.Filter /> Show Filters
        </button>
      </div> */}

     <CabInquiryModal
  isOpen={modalOpen}
  cab={selectedCab}
  onClose={() => { setModalOpen(false); setSelectedCab(null); }}
/>
    </div>
    
  );
}